/**
 * BreadcrumbList is an enhancement for search engines
 * It looks like this when implemented (taken from examples provided by Google):
 *  <script type="application/ld+json">
 *  {
 *    "@context": "https://schema.org",
 *    "@type": "BreadcrumbList",
 *    "itemListElement": [{
 *      "@type": "ListItem",
 *      "position": 1,
 *      "name": "Books",
 *      "item": "https://example.com/books"
 *    },{
 *      "@type": "ListItem",
 *      "position": 2,
 *      "name": "Science Fiction",
 *      "item": "https://example.com/books/sciencefiction"
 *    },{
 *      "@type": "ListItem",
 *      "position": 3,
 *      "name": "Award Winners"
 *    }]
 *  }
 *  </script>
 * Our implementation of breadcrumbs is an array of objects
 * Each object includes a "title" and a "handle" property.
 * We'll be reading breadcrumb objects and use them to generate the script above.
 * @param {array} breadsArr an array that contains breadcrumb objects with title and handle properties
 * @returns the structured data object or undefined if breadsArr is empty
 */

const buildBreadcrumbList = (breadsArr) => {
    if (!breadsArr.length) {
        return;
    }

    /* Build the structured data object */
    const structuredDataObj = {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        'itemListElement': breadsArr.map((bread, index) => ({
            '@type': 'ListItem',
            'position': (index + 1),
            'name': bread.title,
            'item': new URL(bread.handle, process.env.APP_URL).toString(),
        }))
    };

    // Return the stringified JSON version of the structured data object
    return JSON.stringify(structuredDataObj);
};

export default buildBreadcrumbList;